import { render, staticRenderFns } from "./ElectionRegistrationConfirm.vue?vue&type=template&id=da45b884"
import script from "./ElectionRegistrationConfirm.vue?vue&type=script&lang=js"
export * from "./ElectionRegistrationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports